import { MouseEventHandler, ReactNode } from 'react'
import { Button } from '@campgladiator/cgui-core.atoms.button'
import styles from './attachment-wrapper.module.scss'

type AttachmentWrapperProps = {
  children?: ReactNode
  disabled?: boolean
  handleRemoveAttachment?: MouseEventHandler<HTMLElement>
}

const AttachmentWrapper = ({
  handleRemoveAttachment,
  disabled,
  children,
}: AttachmentWrapperProps) => (
  <div className={styles.wrapper}>
    <Button
      disabled={disabled}
      emphasis="secondary"
      data-testid="close"
      className={styles.button}
      variation="outline"
      size="xsmall"
      icon={{ name: 'icon-times', type: 'solid' }}
      onClick={handleRemoveAttachment}
      theme="trainer"
    />
    {children}
  </div>
)

export default AttachmentWrapper
